import request from "../utils/request";

export async function getLossReasonList(payload) {
  return request.get("LossReason/List",{
    params:{
      sortBy: payload.sortBy,
      sortDirection: payload.sortDirection,
      pageIndex: payload.pageIndex,
      pageSize: payload.pageSize,
      lossReasonId: payload.lossReason != null ? payload.lossReason.id : null
    }
  });
}
export async function getLossReasons() {
  return request.get("LossReason/NameList");
}

export async function createLossReason(payload) {
  return request.post("LossReason/Create",payload);
}

export async function updateLossReason(payload) {
  return request.post("LossReason/Update",payload);
}

export async function removeLossReason(payload) {
  return request.delete("LossReason/Delete?id=" + payload);
}
